

import { QuestionBase, QuestionElement, QuestionUITypes } from './question-base';
import { QuestionCol2 } from './question-col2';

export class QuestionRow {
  public childrenInRow = true;
  public firstChild: QuestionElement;
  public lastChild: QuestionElement;
  public prev: QuestionElement;
  public next: QuestionElement;
  public questionType: QuestionUITypes = QuestionUITypes.ROW;

  public questions: { [key: string]: QuestionElement } = {};

  constructor(
    public key: string
  ) {

  }

  public displayChildrenInRow(){
    return this.childrenInRow;
  }

  public addQuestion(newQuestion: QuestionElement) {
    if (!this.firstChild) {
      this.firstChild = newQuestion;
      this.lastChild = newQuestion;
    } else {
      this.lastChild.next = newQuestion;
      newQuestion.prev = this.lastChild;
      this.lastChild = newQuestion;
    }

    this.questions[newQuestion.key] = newQuestion;
  }

  public getQuestionsFlat() : { [key : string] : QuestionBase<any> } {
    let responseObj = {};
    
    for (let key in this.questions) {
      let questionCurrent = this.questions[key];
      
      if( questionCurrent instanceof QuestionRow ) {
        let tmp = Object.assign( {}, questionCurrent.getQuestionsFlat() )

        for( let keyTmp in tmp ){
          if( keyTmp in responseObj ){
            console.error( 'key ' + responseObj + ' exists multiple times' );
          }else{
            responseObj[keyTmp] = tmp[keyTmp];
          }
        }
      }else{
        responseObj[key] = questionCurrent;
      }
    }

    return responseObj;
  }

  public getQuestionsFlatArr() : Array<QuestionBase<any>> {
    return Object.values( this.getQuestionsFlat() );
  }

  public getQuestionsElementsInOrder(): Array<QuestionElement> {
    let ret : Array<QuestionElement> = [];
    let tmp : QuestionElement = this.firstChild;

    while( tmp ){
      ret.push(tmp);
      tmp = tmp.next;
    }

    return ret;
  }

  public forEach( func : ( param : QuestionBase<any> ) => void ){
    let tmp : QuestionElement = this.firstChild;

    while( tmp ){
      if( tmp instanceof QuestionRow ){
        tmp.forEach( func );
      }else{
        func( tmp );
      }

      tmp = tmp.next;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/question-row.ts